import { FILTER_QUERIES } from '../../models/filters';

const queryKeys = {
  SEARCH: {
    accommodationKey: 'AccBookKey',
    accommodationKeys: 'AccomodationKeys',
    bestPrice: 'BestPrice',
    bookingEngineKey: 'StrBookingEngineKey',
    cabinClass: 'CabinClass',
    categoryId: 'CategoryId',
    changeCabin: 'ChangeCabin',
    classifications: 'classifications',
    cruiseCode: 'CruiseCode',
    cruiseId: 'CruiseId',
    directFlight: 'DirectFlight',
    fastestFlight: 'FastestFlight',
    hotelCode: 'HotelCode',
    hotelId: 'HotelId',
    hotelWvId: 'HotelWvId',
    includeBaggage: 'IncludeBaggage',
    isStandalone: 'IsStandalone',
    noExtras: 'noExtras',
    price: 'Price',
    recommended: 'recommended',
    resortWvId: 'ResortWvId',
    roomGroupKey: 'RoomGroupKey',
    selectedCabin: 'SelectedCabin',
    selectedHotelCode: 'SelectedHotelCode',
    sequence: 'Sequence',
    sessionId: 'SessionId',
    showPriceCalendar: 'showPriceCalendar',
    siteId: 'siteId',
    sortKey: 'sortKey',
    tags: 'tags',
    tdmRuleId: 'TdmRuleId',
    tdmType: 'tdmType',
    transportId: 'TransportId',
    transportKey: 'TransportKey',
    tripContext: 'TripContext',
    tripRuleId: 'TripRuleId',
  },

  QUERY: {
    adults: 'QueryAdults',
    ages: 'QueryAges',
    areaId: 'QueryAreaID',
    areaWvId: 'QueryAreaWvID',
    chkInDate: 'QueryChkInDate',
    checkInDate: 'QueryCheckInDate',
    chkOutDate: 'QueryChkOutDate',
    checkOutDate: 'QueryCheckOutDate',
    childrenAges: 'QueryChildrenAges',
    countryId: 'QueryCtryID',
    departureCode: 'QueryDepCD',
    departureDate: 'QueryDepDate',
    departureId: 'QueryDepID',
    departureWvId: 'QueryDepWvID',
    destinationAirportId: 'QueryDestID',
    destinationId: 'QueryDestID',
    duration: 'QueryDur',
    resortId: 'QueryResID',
    resortWvId: 'QueryResWvID',
    returnDate: 'QueryRetDate',
    roomDistribution: 'QueryRoomAges',
    type: 'QueryType',
    units: 'QueryUnits',
  },
  FILTER: FILTER_QUERIES,
  SCROLL_POSITION: 'scrollPosition',
  CRUISE_FILTERS: {
    cruiseCategory: 'f_cat',
    departureMonth: 'f_depmonth',
    destination: 'f_dest',
    duration: 'f_dur',
    numberOfDestinations: 'f_ndest',
    shippingCompany: 'f_company',
    shipRating: 'f_rating',
  },
  PACKAGE_PLUS_FILTERS: {
    classifications: 'f_classifications',
  },
};

export default queryKeys;
